import React from 'react';
import Products from './Products';
import Footer from '../components/Footer';

function Home() {
    return (
        <>
            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-content">
                    <h1>Transform Your Ideas Into Reality</h1>
                    <p>Professional Web & Mobile App Development Solutions</p>
                    <div>
                        <button className="btn btn-primary-hero">Get Started</button>
                        <button className="btn btn-secondary-hero">Learn More</button>
                    </div>
                </div>
            </section>

            {/* About Section */}
            <section className="about-company">
                <h2>🚀 Welcome to NeeBun</h2>
                <p>
                    At <strong>NeeBun</strong>, we specialize in creating innovative, scalable, and user-friendly web and mobile applications. 
                    With a team of experienced developers, designers, and strategists, we transform your business ideas into cutting-edge digital solutions.
                </p>
                <p style={{marginBottom: 0}}>
                    Our expertise spans across modern technologies, ensuring your application is built to last and scale with your business needs.
                </p>
            </section>

            {/* Services Section */}
            <div className="section-title">
                <h2>Our Services</h2>
                <p>Comprehensive solutions tailored to elevate your digital presence</p>
            </div>

            {/* Products/Services */}
            <Products />
            
            {/* <Footer /> */}
        </>
    );
}

export default Home;
